import { createContext } from 'react';

type PowerSearchActiveGroupContextValue = {
  activeGroupId: string;
  expandedGroupIds: ReadonlySet<string>;
  toggleExpandedGroupId(groupId: string): void;
  beforeGroupToggle(groupId: string): void;
};

export const PowerSearchActiveGroupContext = createContext<PowerSearchActiveGroupContextValue>({
  activeGroupId: '',
  expandedGroupIds: new Set(),
  toggleExpandedGroupId: () => undefined,
  beforeGroupToggle: () => undefined,
});
PowerSearchActiveGroupContext.displayName = 'PowerSearchActiveGroupContext';
